import commonThemeOverrides from '@/theme/commonThemeOverrides'

/**
 * @type import('naive-ui').GlobalThemeOverrides
 */
export default {
  ...commonThemeOverrides
}
